module.exports = __webpack_public_path__ + "static/galaxy.307691e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/libraries/galaxy.jpg
// module id = 501
// module chunks = 248600712657012